import config from 'config';

const LOAD = 'horse-racing/horseProfile/LOAD';
const LOAD_SUCCESS = 'horse-racing/horseProfile/LOAD_SUCCESS';
const LOAD_FAIL = 'horse-racing/horseProfile/LOAD_FAIL';
const LOAD_RESET = 'horse-racing/horseProfile/LOAD_RESET';

const initialState = {
  profile: {}
}

export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case LOAD:
      return {
        ...state,
        loading: true
      };
    case LOAD_SUCCESS:
      return {
        ...state,
        loading: false,
        loaded: true,
        profile: action.result
      };
    case LOAD_FAIL:
      return {
        ...state,
        loading: false,
        loaded: false,
        error: action.error
      };
    case LOAD_RESET:
      return {
        ...state,
        loading: false,
        loaded: false
      };
    default:
      return state;
  }
}

export function isProfileLoaded({ horseRacing: { horseProfile: { loading, loaded } } }) {
  return (loading || loaded);
}

export function resetProfileLoaded() {
  return { type: LOAD_RESET }
}

export function load(horseId) {
  return {
    types: [LOAD, LOAD_SUCCESS, LOAD_FAIL],
    promise: client => client.get(`${config.api.horseRacing.horse}/${horseId}`)
  };
}



// WEBPACK FOOTER //
// ./modules/HorseRacing/reducers/horseProfile.js